import classNames from "classnames";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Checkbox, Icon } from "../../../components";
import { useMediaQuery } from "../../../hooks";
import { Spacer } from "../../spacer";
import styles from "./portal_booking_price_details.module.css";
import { PortalButton } from "./portal_button";

interface PortalBookingItem {
  label: string;
  price: string;
  isDiscount?: boolean;
  tooltip?: JSX.Element;
}

interface PortalBookingPriceDetailsProps {
  items: PortalBookingItem[];
  total: string;
  currency: string;
  hasActions?: boolean;
  partnerId?: string;
}

export function PortalBookingPriceDetails({
  items,
  total,
  currency,
  hasActions,
  partnerId,
}: PortalBookingPriceDetailsProps) {
  const { device } = useMediaQuery();
  const [changingCard, setChangingCard] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        {device !== "mobile" && (
          <div>
            <div className={styles.title}>Price details</div>
            <Spacer size={16} />
          </div>
        )}
        {items.map((item, index) => {
          const classes = classNames(
            styles.row,
            item.isDiscount && styles.discountItem
          );
          return (
            <div key={index} className={classes}>
              <div>
                {item.label}{" "}
                {item.tooltip && (
                  <OverlayTrigger overlay={<Tooltip>{item.tooltip}</Tooltip>}>
                    <span>
                      <Icon name="info" size={16} color="#06001E" />
                    </span>
                  </OverlayTrigger>
                )}
              </div>
              <div>{item.price}</div>
            </div>
          );
        })}
      </div>
      {hasActions && (
        <div className={styles.section}>
          <div className={styles.title}>Promo code</div>
          <Spacer size={10} />
          <div className={styles.codeInputWrapper}>
            <input placeholder="Enter a code" className={styles.codeInput} />
            <button className={styles.codeApplyBtn}>Apply</button>
          </div>
        </div>
      )}
      <div className={styles.section}>
        {!changingCard && (
          <div className={styles.row}>
            <div className={styles.title}>•••• 1234</div>
            {hasActions && (
              <PortalButton
                appearance="text"
                onClick={() => setChangingCard(true)}
              >
                Change card
              </PortalButton>
            )}
          </div>
        )}
        {changingCard && partnerId && (
          <div>
            <Spacer size={16} />
            <div className={styles.checkWrapper}>
              <Checkbox value={true} />
              <div>Use this card for all membership purchases</div>
            </div>
            <Spacer size={16} />
            <PortalButton
              appearance="text"
              onClick={() => setChangingCard(false)}
            >
              Undo card change
            </PortalButton>
            <Spacer size={16} />
          </div>
        )}
        <div className={styles.row}>
          <div className={styles.totalText}>Total ({currency})</div>
          <div className={styles.totalText}>{total}</div>
        </div>
      </div>
    </div>
  );
}
